import PlayerBettingInfoCard from './PlayerBettingInfoCard.svelte';

!customElements.get('player-betting-info-card') && customElements.define('player-betting-info-card', PlayerBettingInfoCard);
export default PlayerBettingInfoCard;
